module.exports = __webpack_public_path__ + "static/media/map.95246bc9.svg";